<template>
    <div class="main_unit">
        <div class="top_unit">
            <div class="top_center_box"> </div>
        </div>
        <div class="main_unit">
            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div class=" wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">

                <div v-if="validationMessage">
                    <Message :validationMessage="alertMessage" /><br>
                    <Message :validationMessage="validationMessage" />
                </div>

                <table class="alert_tbl_unit_prm" style="max-height: 500px">
                    <tbody class="alert_tbl_unit_prm_scroll">
                        <tr>
                            <th class="wd140 alertList_text_align">リリースカテゴリ</th>
                            <th class="wd720 alertList_text_align">お知らせ内容</th>
                            <th class="wd250 alertList_text_align">ページURL</th>
                            <th class="wd110_fix_min alertList_text_align ">作成日</th>
                            <th class="wd110_fix_min alertList_text_align ">お知らせ終了</th>
                        </tr>
                        <tr v-for="(releaseSetting,index) in releaseSettingListData" :key="index">
                            <td  class="wd140 alertList_text_align text_white_space" :class="releaseSetting.id == null || (releaseSetting.id != null && releaseSetting.deleteFlg == 0) ? 'alert_table_background-color' : 'dialog_background-color_disabled'">
                              <select v-if="releaseSetting.id == null" :value="releaseSetting.releaseCategoryId" v-model="releaseSetting.releaseCategoryId">
                                <option value="" disabled selected>選択</option>
                                <option v-for="(type, index) in releaseCategories" :key="index+1" :value="index+1">{{type}}</option>
                              </select>
                              <p v-else>{{releaseCategories[releaseSetting.releaseCategoryId-1]}}</p>
                            </td>
                            <td  class="wd720" :class="releaseSetting.id == null || (releaseSetting.id != null && releaseSetting.deleteFlg == 0) ? 'alert_table_background-color' : 'dialog_background-color_disabled'">
                              <textarea v-if="releaseSetting.id == null" class="alert_textbox alert_table_background-color" placeholder="対応内容を入力"  maxlength="100" v-model="releaseSetting.contents">
                              </textarea>
                              <p v-else style="text-align: left">{{releaseSetting.contents}}</p>
                            </td>
                            <td class="wd250" :class="releaseSetting.id == null || (releaseSetting.id != null && releaseSetting.deleteFlg == 0) ? 'alert_table_background-color' : 'dialog_background-color_disabled'">
                              <textarea v-if="releaseSetting.id == null" class="alert_textbox alert_table_background-color" placeholder="遷移先URLを入力"  maxlength="100" v-model="releaseSetting.url">
                              </textarea>
                              <p v-else style="text-align: left">{{releaseSetting.url}}</p>
                            </td>
                            <td class="wd100_fix_min alertList_text_align text_white_space" :class="releaseSetting.id == null || (releaseSetting.id != null && releaseSetting.deleteFlg == 0) ? 'alert_table_background-color' : 'dialog_background-color_disabled'">{{releaseSetting.createdDatetime}}</td>
                            <td class="alert_table_background-color" :class="releaseSetting.id == null || (releaseSetting.id != null && releaseSetting.deleteFlg == 0) ? 'alert_table_background-color' : 'dialog_background-color_disabled'">
                              <div v-if="releaseSetting.id != null" class="checkSetting_kanri_box ">
                                <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="doneSelect(index)">終了</a></li></ul>
                              </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="btn_submit letter_spa">
                    <a href="#" role="button" @click.prevent.stop="sendCheckModel()" >登録</a>
                </div>
            </div>
        </div>

        <div class="overlay" v-show="showContent">
          <div>
            <div class="modal_box wd512">
              <div class="modal_header_unit">
                <div class="modal_header_box">
                  <p class="modal_header_tit">お知らせ設定登録</p>
                </div>
              </div>
              <div class="modal_content_tex">
                <p>お知らせを登録してよろしいですか。<br>
                  {{releaseSettingListData[0]["contents"]}}
                </p>
              </div>
              <div class="btn_submit_box">
                <div class="btn_submit2">
                  <a href="#" @click.prevent.stop="closeSendCheckModel">キャンセル</a>
                </div>
                <div class="btn_submit">
                  <a href="#" @click.prevent.stop="sendInput()">登録</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overlay" v-show="showContent2">
          <div>
            <div class="modal_box wd512">
              <div class="modal_header_unit">
                <div class="modal_header_box">
                  <p class="modal_header_tit_s"></p>
                  <p class="modal_header_tit">お知らせ設定</p>
                </div>
              </div>
              <div class="modal_content_tex">
                <p>お知らせの設定が完了しました。</p>
              </div>
              <div class="btn_submit_box">
                <div class="btn_submit2">
                  <a role="button" @click.prevent.stop="closeModal()">閉じる</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overlay" v-show="showContent3">
          <div>
            <div class="modal_box wd512">
              <div class="modal_header_unit">
                <div class="modal_header_box">
                  <p class="modal_header_tit">お知らせ設定終了</p>
                </div>
              </div>
              <div class="modal_content_tex">
                <p>お知らせを終了してよろしいですか
                </p>
              </div>
              <div class="btn_submit_box">
                <div class="btn_submit2">
                  <a href="#" @click.prevent.stop="closeUpdateCheckModel">キャンセル</a>
                </div>
                <div class="btn_submit">
                  <a href="#" @click.prevent.stop="sendDoneInput()">終了</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'

    export default {
        name: 'ReleaseList',
        components: {
            PulseLoader,
            Message
        },
        computed:{
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
        },
        data: function () {
            return {
                isInitLoading:true,
                validationMessage:"",
                alertMessage:'入力エラーがあります。',
                releaseSettingList:[],
                releaseSettingListData:[],
                showContent:false,
                showContent2:false,
                showContent3:false,
                isLoading:false,
                type:0,
                releaseCategories:["メンテナンス情報"],
                selectDoneIndex:null,
            }
        },
        mounted () {

        },
        created: function(){
            this.calc();
        },
        methods:{
            calc:async function(){

                this.isInitLoading = true;


                // DBデータ取得
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/releaseSetting/list')
                    .then(response => (this.releaseSettingList = response['data']['releaseSetting']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);

                this.dataSet();
            },
            sendCheckModel(){
              //バリデーションフラグ
              var validationFlg = true;
              //バリデーションチェック(桁数)
              this.validationMessage = '';
              let sendInput = this.releaseSettingListData[0];

              validationFlg = this.inputValidate(sendInput);
              if(!validationFlg){
                this.isLoading = false;
                this.scrollTop();
                //処理終了
                return null;
              }
              this.showContent = true;
            },
            //更新処理
            async sendInput(){
              this.showContent = false;
              this.isLoading = true;
              //バリデーションチェック(桁数)
              this.validationMessage = '';
              var apiResponseFlg = true;
              let input = this.releaseSettingListData[0];
              let releaseCategoryId = input['releaseCategoryId'];
              let contents = input['contents'];
              let url = input['url'];

                //更新API呼び出し
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/releaseSetting/list', {release_category_id:releaseCategoryId,contents:contents,url:url})
                    .then(response => (this.releaseSettingList = response['data']['release_setting']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        this.isLoading = false;
                        this.scrollTop();
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.validationMessage =  error.message;
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    });

                // 処理エラーがない場合
                if(apiResponseFlg){
                    this.isLoading = false;
                    this.showContent2 = true;
                    this.dataSet();
                }
            },
            closeSendCheckModel(){
              this.showContent = false;
            },
            closeUpdateCheckModel(){
              this.showContent3 = false;
              this.selectDoneIndex = null;
            },
            closeModal(){
                this.showContent2 = false;
                // 画面最新化
                this.calc();
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
            doneSelect(indexCount){
                this.selectDoneIndex = null;
                let releaseSetting = this.releaseSettingListData[indexCount];
                if(releaseSetting.deleteFlg != 1){
                  this.showContent3 = true;
                  this.selectDoneIndex = indexCount;
                }
            },
            async sendDoneInput(){
              this.showContent3 = false;
              this.isLoading = true;
              //バリデーションフラグ
              var validationFlg = true;
              //バリデーションメッセージ
              this.validationMessage = '';
              var apiResponseFlg = true;
              validationFlg = this.selectDoneIndex != null;
              let input = this.releaseSettingListData[this.selectDoneIndex];
              validationFlg = input["id"] != null;

              if(!validationFlg){
                this.isLoading = false;
                this.scrollTop();
                //処理終了
                return null;
              }

              //更新API呼び出し
              await this.$axios
                  .post(this.$apiEndpoint + 'manage/releaseSetting/update', {id:input["id"]})
                  .then(response => (this.releaseSettingList = response['data']['release_setting']))
                  .catch((err) => {
                    let error = {
                      button: {
                        path: {name: 'top', params:{brandPath: this.brandPath}}
                      }}
                    apiResponseFlg = false;
                    this.isLoading = false;
                    this.scrollTop();
                    if (err.customError) {
                      error = Object.assign(error, err.customError);

                      if(error.code == 400){
                        this.validationMessage =  error.message;
                      }
                    }
                    if(error.code !== 400){
                      this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                  });

              // 処理エラーがない場合
              if(apiResponseFlg) {
                this.isLoading = false;
                this.showContent2 = true;
                this.dataSet();
              }
              this.selectDoneIndex = null;
            },
            inputValidate(input) {
              let releaseCategoryId = input['releaseCategoryId'];
              let contents = input['contents'];
              let url = input['url'];
              // 必須チェック
              if(releaseCategoryId == 0){
                this.validationMessage="カテゴリが選択されていません。"
                return false;
              }
              if(String(contents).length <= 0){
                this.validationMessage="おせらせ内容を入力してください。"
                return false;

              }
              if(String(url).length <= 0){
                this.validationMessage="ページURLを入力してください。"
                return false;
              }

              // 桁数チェック
              if(String(contents).length > 100){
                this.validationMessage="おせらせ内容は100桁以内で入力してください。"
                return false;

              }
              if(String(url).length > 100){
                this.validationMessage="ページURLは100桁以内で入力してください。"
                return false;
              }
              return true;
            },
            dataSet() {
              let addInputItem = {
                "id": null,
                'releaseCategoryId': "",
                'contents': "",
                'url': "",
                'deleteFlg': "0",
                'createdDatetime': ""
              }
              let settingData = [];
              settingData.push(addInputItem);
              this.releaseSettingList.forEach(item => {
                let addItem = {
                  "id": item["id"],
                  'releaseCategoryId': item["releaseCategoryId"],
                  'contents': item["contents"],
                  'url': item["url"],
                  'deleteFlg': item["deleteFlg"],
                  'createdDatetime': item["createdDatetime"],
                }
                settingData.push(addItem);
              });

              this.releaseSettingListData = settingData;
            }
        }
    }
</script>

